module.exports = __webpack_public_path__ + "img/bank-uncheck-reviewed-disabled.089b6dd9.svg";